/**
 *
 * TruncateTextTooltip
 *
 */

import React from "react"
import TruncateText from "components/TruncateText"
import { Tooltip } from "antd"
// import PropTypes from 'prop-types';
// import styled from 'styled-components';

class TruncateTextTooltip extends React.Component {
  mount = false
  state = { showTooltip: false }

  UNSAFE_componentWillMount() {
    this.mount = true
  }

  componentWillUnmount() {
    this.mount = false
  }

  render() {
    const { showTooltip } = this.state
    const { line, title, truncate } = this.props
    return (
      <Tooltip title={showTooltip ? title : null}>
        <TruncateText
          line={line || 1}
          text={title}
          truncateText={truncate || "..."}
        />
      </Tooltip>
    )
  }
}

TruncateTextTooltip.propTypes = {}

export default TruncateTextTooltip
